import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import { ICategory } from "./categoryModel";

export const findAllCategory = createAsyncThunk(
  "Category/FindAllCategory",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/FindAllCategory`,
        {
          Title: "",
        },
      );
      return response.data?.Data.map((item: any) => ({
        ...item,
        IsActive: item.IsActive || false,
      }));
    } catch (error: any) {
      console.error("Error Fetching Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertCategory = createAsyncThunk(
  "Category/InsertCategory",
  async (categoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/InsertCategory`,
        categoryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateCategory = createAsyncThunk(
  "Category/UpdateCategory",
  async (categoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/UpdateCategory`,
        categoryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDCategory = createAsyncThunk(
  "Category/FindByIDCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/FindByIDCategory`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive || false,
      } as ICategory;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllActiveCategory = createAsyncThunk(
  "Category/FindAllActiveCategory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Category/FindAllActiveCategory`,
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveCategory = createAsyncThunk(
  "Category/ActiveInActiveCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/ActiveInActiveCategory`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteCategory = createAsyncThunk(
  "Category/DeleteCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Category/DeleteCategory`,
        {
          ID,
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
